import type { ReactNode } from 'react'

type CarouselResponsiveLayoutProps = {
  mobile: ReactNode
  tablet: ReactNode
  desktop: ReactNode
}

export const CarouselResponsiveLayout = ({
  mobile,
  tablet,
  desktop,
}: CarouselResponsiveLayoutProps) => (
  <div>
    <div className='d-block d-md-none'>{mobile}</div>
    <div className='d-none d-md-block d-lg-none'>{tablet}</div>
    <div className='d-none d-lg-block'>{desktop}</div>
  </div>
)
